<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochd"><a id="page_5"></a><span class="bold">CONTENTS</span></h1>
<h2 class="tocf"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocf"><a href="#/xhtml/06_Introduction">Introduction</a></h2>
<h2 class="toc1"><a href="#/xhtml/08_Part1"><span class="bold">PART ONE: THE SECRET WAR BEGINS</span></a></h2>
<h3 class="toc2"><a href="#/xhtml/09_Chapter1">Chapter 1: Colby’s Covert War</a></h3>
<h3 class="toc2"><a href="#/xhtml/10_Chapter2">Chapter 2: Switching Back—SOG Is Born</a></h3>
<h3 class="toc2"><a href="#/xhtml/11_Chapter3">Chapter 3: Shining Brass</a></h3>
<h2 class="toc1"><span href="#/xhtml/12_Part2" title="Link target outside of Sample"><span class="bold">PART TWO: THE HO CHI MINH TRAIL</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/13_Chapter4" title="Link target outside of Sample">Chapter 4: Unfolding the Mysteries of the Trail</span></h3>
<h2 class="toc1"><span href="#/xhtml/14_Part3" title="Link target outside of Sample"><span class="bold">PART THREE: SOG’S AIR ARM</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/15_Chapter5" title="Link target outside of Sample">Chapter 5: Blackbirds and Night Skies</span></h3>
<h3 class="toc2"><span href="#/xhtml/16_Chapter6" title="Link target outside of Sample">Chapter 6: Special Helicopters and Special Crews</span></h3>
<h3 class="toc2"><span href="#/xhtml/17_Chapter7" title="Link target outside of Sample">Chapter 7: FACs and Fighters</span></h3>
<h2 class="toc1"><span href="#/xhtml/18_Part4" title="Link target outside of Sample"><span class="bold">PART FOUR: RECON WEAPONS, MISSIONS, AND TACTICS</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/19_Chapter8" title="Link target outside of Sample">Chapter 8: Recon Equipment and Weapons</span></h3>
<h3 class="toc2"><span href="#/xhtml/20_Chapter9" title="Link target outside of Sample">Chapter 9: Recon Missions</span></h3>
<h3 class="toc2"><span href="#/xhtml/21_Chapter10" title="Link target outside of Sample">Chapter 10: NVA Counterrecon Forces and Tactics</span></h3>
<h3 class="toc2"><span href="#/xhtml/22_Chapter11" title="Link target outside of Sample">Chapter 11: Recon Tactics and Techniques</span></h3>
<h2 class="toc1"><span href="#/xhtml/23_Part5" title="Link target outside of Sample"><span class="bold">PART FIVE: RECON OPERATIONS</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/24_Chapter12" title="Link target outside of Sample">Chapter 12: Getting Teams In and Out</span></h3>
<h3 class="toc2"><span href="#/xhtml/25_Chapter13" title="Link target outside of Sample">Chapter 13: HALO: The Ultimate Infiltration Technique</span></h3>
<h3 class="toc2"><span href="#/xhtml/26_Chapter14" title="Link target outside of Sample">Chapter 14: The Recon Ethic</span></h3>
<h3 class="toc2"><span href="#/xhtml/27_Chapter15" title="Link target outside of Sample">Chapter 15: Into Cambodia</span></h3>
<h2 class="toc1"><a id="page_6"></a><span href="#/xhtml/28_Part6" title="Link target outside of Sample"><span class="bold">PART SIX: SOG’S HATCHET FORCES</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/29_Chapter16" title="Link target outside of Sample">Chapter 16: Hatchet Force Operations</span></h3>
<h3 class="toc2"><span href="#/xhtml/30_Chapter17" title="Link target outside of Sample">Chapter 17: Operation Tailwind</span></h3>
<h2 class="toc1"><span href="#/xhtml/31_Part7" title="Link target outside of Sample"><span class="bold">PART SEVEN: OTHER FRONTS IN THE SECRET WARS</span></span></h2>
<h3 class="toc2"><span href="#/xhtml/32_Chapter18" title="Link target outside of Sample">Chapter 18: Bright Light Rescues</span></h3>
<h3 class="toc2"><span href="#/xhtml/33_Chapter19" title="Link target outside of Sample">Chapter 19: The Greatest Raid of All</span></h3>
<h3 class="toc2"><span href="#/xhtml/34_Chapter20" title="Link target outside of Sample">Chapter 20: SOG in the Defense</span></h3>
<h3 class="toc2"><span href="#/xhtml/35_Chapter21" title="Link target outside of Sample">Chapter 21: SOG’s Darkest Programs</span></h3>
<h3 class="toc3"><span href="#/xhtml/36_Afterword" title="Link target outside of Sample">Afterword</span></h3>
<h3 class="toc2"><span href="#/xhtml/37_Glossary" title="Link target outside of Sample">Glossary</span></h3>
<div class="img_container">
<img alt="Images" src="images/f0005-1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?16856492